import { LucideIcon } from 'lucide-react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectInputProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder: string;
  options: SelectOption[];
  icon?: LucideIcon;
}

export function SelectInput({
  id,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder,
  options,
  icon: Icon,
}: SelectInputProps) {
  const baseClasses =
    'block w-full pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-[#E34290] focus:border-transparent bg-white dark:bg-gray-800 text-theme-light-text-primary dark:text-theme-dark-text-primary transition-colors';
  const iconClasses = Icon ? 'pl-10' : 'pl-3';

  return (
    <div className="relative">
      {Icon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Icon className="h-5 w-5 text-theme-light-text-muted dark:text-theme-dark-text-muted" />
        </div>
      )}
      <select
        id={id}
        name={name}
        required={required}
        className={`${baseClasses} ${iconClasses}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
